const React = require("react");

export default () => (
  <span className="glyphicon glyphicon-ok" />
);
